module.exports = __webpack_public_path__ + "static/media/IMG_0287.d151839f.JPG";